import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="max-w-2xl mx-auto px-6 py-32 text-center">
      <div className="label-eyebrow">404</div>
      <h1 className="font-display text-6xl mt-4">Lost in the bazaar.</h1>
      <p className="text-sm text-[#5C5454] mt-4">The thread you were following has wandered. Let's get you back.</p>
      <Link to="/" data-testid="notfound-home" className="inline-block mt-8 bg-[#6B1A24] text-[#FAFAF7] px-8 py-4 uppercase text-xs tracking-[0.25em] hover:bg-[#8A2532] transition-colors">Return Home</Link>
    </div>
  );
}
